document.addEventListener("DOMContentLoaded", function() {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }

  document.querySelectorAll('[data-popup-conta]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();

      document.querySelectorAll('.popup-account.open').forEach(el => {
        if (el !== btn.nextElementSibling) el.classList.remove('open');
      });
      const popup = btn.nextElementSibling?.classList.contains('popup-account')
        ? btn.nextElementSibling
        : btn.parentElement.querySelector('.popup-account');

      if (popup) {
        popup.classList.toggle('open');
      }
    });
  });

  document.addEventListener('click', (e) => {
    const isButton = e.target.closest('[data-popup-conta]');
    const isPopup = e.target.closest('.popup-account');
    if (!isButton && !isPopup) {
      document.querySelectorAll('.popup-account.open').forEach(el => el.classList.remove('open'));
    }
  });
});

(function () {
  var styleId = 'force-popup-button-style';
  if (!document.getElementById(styleId)) {
    var s = document.createElement('style');
    s.id = styleId;
    s.innerHTML = "\
      .__force-popup-button {\
        display: inline-flex !important;\
        align-items: center !important;\
        justify-content: center !important;\
        height: 44px !important;\
        padding: 0 20px !important;\
        background: #ffffff !important;\
        color: #000000 !important;\
        border: none !important;\
        border-radius: 0 !important;\
        font-weight: 600 !important;\
        font-size: 15px !important;\
        text-transform: none !important;\
        box-shadow: 0 6px 18px rgba(0,0,0,0.04) !important;\
        cursor: pointer !important;\
        outline: none !important;\
        position: relative;\
        right: 100px;\
        top: 16px;\
      }\
      .__force-popup-button, .__force-popup-button * {\
        color: #000000 !important;\
      }\
      .__force-popup-button:hover, .__force-popup-button:hover * {\
        background: #232323 !important;\
        color: #ffffff !important;\
        transform: translateY(-1px) !important;\
          box-shadow: 0 10px 24px rgba(0,0,0,0.14) !important;\
      }\
    ";
    document.head.appendChild(s);
  }

  var selectors = [
    '[aria-modal="true"] button',
    'div[role="dialog"] button',
    '.app-forms button',
    '.app-form button',
    '.app-popup button',
    '.app-modal button',
    '.af-form button',
    '.jf-form button',
    '._formSubmitButton_cit2d_96',
    'div._gridItem_1q1d2_172 ._formSubmitButton_cit2d_96',
    '.formify button',
    '.popup button',
    '.modal button',
    '.halo-popup button',
    '.newsletter-popup button',
    '.newsletter-success-modal button',
    '[data-app] button'
  ];

  function forceStyleButton(btn) {
    if (!btn) return;
    if (btn.dataset.__forcePopupStyled) return;
    try {
      btn.classList.add('__force-popup-button');
      btn.dataset.__forcePopupStyled = '1';
    } catch (e) {}
  }

  function scanAndForce(root) {
    try {
      var q = selectors.join(',');
      var list = (root || document).querySelectorAll(q);
      list.forEach(forceStyleButton);
      
      var textRegex = /receber/i;
      var candidates = (root || document).querySelectorAll('button, a, input[type="submit"]');
      candidates.forEach(function (el) {
        try {
          var t = (el.innerText || el.value || '').trim();
          if (t && textRegex.test(t)) {
            forceStyleButton(el);
          }
        } catch (e) {}
      });
    } catch (e) {}
  }

  scanAndForce(document);

  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;
        
        if (node.matches && node.matches(selectors.join(','))) {
          forceStyleButton(node);
        }
        
        scanAndForce(node);
      });
    });
  });

  mo.observe(document.documentElement || document.body, { childList: true, subtree: true });

  

  function injectStyleIntoShadowRoot(shadow) {
    if (!shadow || !(shadow instanceof ShadowRoot)) return;
    try {
      if (shadow.host && shadow.host.dataset && shadow.host.dataset.__forcePopupShadowInjected) return;
      var sid = 'force-popup-button-style-shadow';
      if (!shadow.getElementById || !shadow.getElementById(sid)) {
        var ss = document.createElement('style');
        ss.id = sid;
        ss.textContent = "\
          /* Buttons inside shadow root */\
          button, a, input[type=submit] {\
            display: inline-flex !important;\
            align-items: center !important;\
            justify-content: center !important;\
            height: 44px !important;\
            background: #fff !important;\
            color: #232323 !important;\
            border: 1px solid #232323 !important;\
            border-radius: 0px !important;\
            font-weight: 600 !important;\
            font-size: 15px !important;\
            box-shadow: 0 6px 18px rgba(0,0,0,0.04) !important;\
            cursor: pointer !important;\
            position: relative;\
            top: 25px;\
            @media (max-width: 600px) {\
            position: relative;\
            right: 100px;\
            top: 16px;\
          }\
          }\
          button, a, input[type=submit] * {\
            color: inherit !important;\
          }\
          button:hover, a:hover, input[type=submit]:hover, button:hover *, a:hover *, input[type=submit]:hover * {\
            background: #232323 !important;\
            color: #fff !important;\
            transform: translateY(-1px) !important;\
            box-shadow: 0 10px 24px rgba(0,0,0,0.14) !important;\
          }\
        ";
        try { shadow.appendChild(ss); } catch (e) { try { shadow.insertBefore(ss, shadow.firstChild); } catch (e2) {} }
      }
      if (shadow.host && shadow.host.dataset) shadow.host.dataset.__forcePopupShadowInjected = '1';
    } catch (e) {}
  }

  function scanForShadowRoots(root) {
    try {
      var nodes = (root || document).querySelectorAll('*');
      nodes.forEach(function (n) {
        if (n.shadowRoot) injectStyleIntoShadowRoot(n.shadowRoot);
      });
    } catch (e) {}
  }

  
  scanForShadowRoots(document);

  
  var moShadow = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;
        if (node.shadowRoot) injectStyleIntoShadowRoot(node.shadowRoot);
        try { scanForShadowRoots(node); } catch (e) {}
      });
    });
  });
  moShadow.observe(document.documentElement || document.body, { childList: true, subtree: true });

  function findAndMarkGridItem(selector) {
    function processRoot(root) {
      try {
        var el = root.querySelector(selector);
        if (el && !el.dataset.__pvGridMarked) {
          el.dataset.__pvGridMarked = '1';
          

          var wrapper = el.closest('section, div, form') || el;
          wrapper.classList.add('__pv-modal-target');

          if (root instanceof ShadowRoot) {
            try {
              var styleId = 'pv-modal-shadow-style';
              if (!root.getElementById || !root.getElementById(styleId)) {
                var ss = document.createElement('style');
                ss.id = styleId;
                ss.textContent = "\
                  .__pv-modal-target { box-sizing: border-box; }\
                  .__pv-modal-target { display: block; }\
                  .__pv-modal-target ._gridItem_1q1d2_172 { /* keep original */ }\
                  /* minimal layout helpers scoped to shadow root */\
                  .__pv-modal-target { --pv-safe-gap: 20px; }\
                  .__pv-modal-target { padding: 0; }\
                ";
                try { root.appendChild(ss); } catch (e) { try { root.insertBefore(ss, root.firstChild); } catch (e2){} }
              }
            } catch (e) {}
          }
        }
      } catch (e) {}
    }

    try {
      processRoot(document);
      
  
        (function(){
          var selectors = ['.__pv-modal-target', 'div._gridItem_1q1d2_172._gridItemContent_1q1d2_257', 'div._gridItem_1q1d2_172:nth-child(2)'];

          function cleanModalRoot(root) {
            if (!root || root.dataset.__pvCleaned) return;
            try {
              root.dataset.__pvCleaned = '1';

              var closeSel = 'button[aria-label*="close" i], button[aria-label*="fechar" i], .close, .modal-close, [role="button"].close';
              var closes = Array.from(root.querySelectorAll(closeSel));
              if (closes.length > 1) {
                closes.slice(1).forEach(function(c){ try{ c.remove(); }catch(e){} });
              }
              if (closes[0]) {
                try { closes[0].style.zIndex = 9999; closes[0].style.position = closes[0].style.position || 'absolute'; } catch(e){}
              }

              var icons = Array.from(root.querySelectorAll('img, svg'));
              var seen = new Set();
              icons.forEach(function(n){
                try{
                  var key = n.outerHTML;
                  if(seen.has(key)) n.remove(); else seen.add(key);
                } catch(e){}
              });

              var submit = root.querySelector('button[type="submit"], input[type="submit"], button[data-testid="btn-form-submit"], ._formSubmitButton_cit2d_96');
              if(submit) {
                try { submit.classList.add('__force-popup-button'); } catch(e){}
              }

              
            } catch (e) {}
          }

          function findAndClean(context) {
            try {
              selectors.forEach(function(sel){
                var list = (context || document).querySelectorAll(sel);
                Array.from(list).forEach(function(r){ cleanModalRoot(r); });
              });
            } catch(e) {}
          }

          function scanAll() {
            findAndClean(document);
            try { document.querySelectorAll('*').forEach(function(n){ if(n.shadowRoot) { try{ findAndClean(n.shadowRoot); }catch(e){} } }); } catch(e) {}
          }

          setTimeout(scanAll, 300);

          var moCleaner = new MutationObserver(function(muts){
            muts.forEach(function(m){
              m.addedNodes.forEach(function(node){
                if(!(node instanceof Element)) return;
                  try { findAndClean(node); } catch(e){}
                  if(node.shadowRoot) try{ findAndClean(node.shadowRoot); }catch(e){}
              });
            });
          });
          moCleaner.observe(document.documentElement || document.body, { childList: true, subtree: true });
        })();

      document.querySelectorAll('*').forEach(function(n){ if(n.shadowRoot) processRoot(n.shadowRoot); });
    } catch (e) {}
  }

  findAndMarkGridItem('div._gridItem_1q1d2_172:nth-child(2)');

  var gridObserver = new MutationObserver(function(muts){
    muts.forEach(function(m){
      m.addedNodes.forEach(function(node){
        if (!(node instanceof Element)) return;
        if (node.shadowRoot) {
          
          injectStyleIntoShadowRoot(node.shadowRoot);
          try { findAndMarkGridItem('div._gridItem_1q1d2_172:nth-child(2)'); } catch(e){}
        }
        try { findAndMarkGridItem('div._gridItem_1q1d2_172:nth-child(2)'); } catch(e){}
      });
    });
  });
  gridObserver.observe(document.documentElement || document.body, { childList: true, subtree: true });
})();

(function(){
  var MODAL_STYLE_ID = 'pv-modal-scoped-style';
  var modalCss = "\
  .__pv-modal-scoped {\
    background: #fff !important;\
    color: #111 !important;\
    border-radius: 6px !important;\
    max-width: 1200px !important;\
    width: calc(100% - 80px) !important;\
    box-shadow: 0 18px 40px rgba(0,0,0,0.16) !important;\
    padding: 28px !important;\
    box-sizing: border-box !important;\
  }\
  /* classe adicional para controlar largura/estilo específico */\
  .__appforms-custom { max-width: 1200px !important; width: 90% !important; padding: 32px !important; }\
  .__pv-modal-scoped ._textHeading_2aowh_35 { font-size: 20px !important; font-weight: 700 !important; margin-bottom: 6px !important; }\
  .__pv-modal-scoped ._textBody_2aowh_10 p { color: #666 !important; margin: 0 0 12px 0 !important; }\
  .__pv-modal-scoped ._formFieldContainer_1mxsl_5 { margin-bottom: 12px !important; }\
  .__pv-modal-scoped ._formInputField_nag3b_7 { width: 120px !important; padding: 8px 10px !important; border: 1px solid #ddd !important; border-radius: 4px !important; color: #111 !important; }\
  .__pv-modal-scoped ._formSubmitButton_cit2d_96, .__pv-modal-scoped .__force-popup-button { background:#232323 !important; color:#fff !important; border:none !important; padding:10px 18px !important; border-radius:4px !important; }\
  .__pv-modal-scoped ._formSubmitButton_cit2d_96:hover, .__pv-modal-scoped .__force-popup-button:hover { background:#232323 !important; }\
  ";

  
  function ensureModalStyleInDocument(){
    if(!document.getElementById(MODAL_STYLE_ID)){
      var s = document.createElement('style'); s.id = MODAL_STYLE_ID; s.textContent = modalCss; document.head.appendChild(s);
    }
  }

  function injectModalStyleIntoShadow(shadow){
    try{
      if(!shadow || !(shadow instanceof ShadowRoot)) return;
      var sid = MODAL_STYLE_ID + '-shadow';
      if(shadow.getElementById && shadow.getElementById(sid)) return;
      var ss = document.createElement('style'); ss.id = sid; ss.textContent = modalCss; try{ shadow.appendChild(ss); }catch(e){ try{ shadow.insertBefore(ss, shadow.firstChild); }catch(e){} }
    }catch(e){}
  }

  function markModal(rootEl){
    try{
      if(!rootEl) return;
      if(rootEl.classList && rootEl.classList.contains('__pv-modal-scoped')) return;

      
      try{
        var isInlineSection = false;
        if(rootEl.tagName && rootEl.tagName.toUpperCase() === 'SECTION') isInlineSection = true;
        if(!isInlineSection && rootEl.classList && rootEl.classList.length){
          Array.from(rootEl.classList).forEach(function(c){ if(c.indexOf('_formContainer_') === 0) isInlineSection = true; });
        }
        if(isInlineSection) return;
      }catch(e){}

      try{ if(rootEl.dataset && rootEl.dataset.__pvInitialModal === '1') return; }catch(e){}

        try{ var r = rootEl.getBoundingClientRect ? rootEl.getBoundingClientRect() : null; if(r && (r.width < 420 || r.height < 180)) return; }catch(e){}
      rootEl.classList.add('__pv-modal-scoped');
      rootEl.classList.add('__appforms-custom');

      
      
      
      
      
      var submit = rootEl.querySelector('button[type="submit"], input[type="submit"], button[data-testid="btn-form-submit"]');
      if(submit) submit.classList.add('__force-popup-button');

      
      try {
        var fieldSelectors = 'input:not([type=hidden]):not([type=submit]):not([type=button]), textarea, select, ._formFieldContainer_1mxsl_5, .form-field, .form-row, .formRow';
        var candidates = Array.from(rootEl.querySelectorAll(fieldSelectors));
        var visibleFields = candidates.filter(function(el){
          try{ return el.offsetParent !== null || getComputedStyle(el).display !== 'none'; }catch(e){ return true; }
        });
        var kept = 0;
        visibleFields.forEach(function(el){
          var tag = (el.tagName||'').toUpperCase();
          if(tag === 'INPUT'){
            var t = (el.type||'').toLowerCase();
            if(t === 'submit' || t === 'button' || t === 'hidden') return;
          }
          if(kept < 3){ kept++; return; }
          try{ el.style.display = 'none'; el.dataset.__appHidden = '1'; }catch(e){}
        });
      } catch(e){}

      
    }catch(e){}
  }

  function findModalsIn(root){
    try{
      var docRoot = root || document;

      
      try {
        var special = docRoot.querySelector('#838146, [data-product-id="838146"]');
        if (special) {
          var wrapper = special.closest('[role="dialog"], .halo-popup, .app-embed, section, form') || special;
          if (wrapper) {
            var sroot = wrapper.getRootNode && wrapper.getRootNode();
            if (sroot && sroot instanceof ShadowRoot){
              injectModalStyleIntoShadow(sroot);
            } else {
              try{ injectModalStyleIntoShadow(wrapper); }catch(e){}
            }
            markModal(wrapper);
          }
        }
      } catch(e){}

      
      var headingSelectors = ['h1','h2','h3'];
      var headings = docRoot.querySelectorAll(headingSelectors.join(','));
      headings = Array.from(headings).filter(function(h){ var t = (h.textContent||'').trim(); return /Cadastro de Medidas|Provedor Virtual|Cadastro|Recomenda/i.test(t); });
      headings.forEach(function(h){
        var wrapper = h.closest('[role="dialog"], .halo-popup, .app-embed, section, form') || h.parentElement;
        if(wrapper){
          var sroot = wrapper.getRootNode && wrapper.getRootNode();
          if(sroot && sroot instanceof ShadowRoot){ injectModalStyleIntoShadow(sroot); }
          markModal(wrapper);
        }
      });

      
      var modalSelectors = ['[role="dialog"]', '.halo-popup', '.app-embed', '.app-modal', '.newsletter-popup', '.popup', '.modal', '.app-forms', '.app-popup', 'div[role="dialog"]'];
      modalSelectors.forEach(function(sel){
        try{
          var list = docRoot.querySelectorAll(sel);
          Array.from(list).forEach(function(wrapper){
            var sroot = wrapper.getRootNode && wrapper.getRootNode();
            if(sroot && sroot instanceof ShadowRoot){ injectModalStyleIntoShadow(sroot); }
            markModal(wrapper);
          });
        }catch(e){}
      });
    }catch(e){}
  }

  ensureModalStyleInDocument();
  findModalsIn(document);

  try{ document.querySelectorAll('*').forEach(function(n){ if(n.shadowRoot) injectModalStyleIntoShadow(n.shadowRoot); }); }catch(e){}

  var mo = new MutationObserver(function(muts){
    muts.forEach(function(m){
      m.addedNodes.forEach(function(node){
        if(!(node instanceof Element)) return;
        try{ findModalsIn(node); }catch(e){}
        if(node.shadowRoot) try{ injectModalStyleIntoShadow(node.shadowRoot); findModalsIn(node.shadowRoot); }catch(e){}
      });
    });
  });
  mo.observe(document.documentElement||document.body,{ childList:true, subtree:true });

  document.addEventListener('click', function(e){ var f = e.target.closest('iframe'); if(f) { } });
})();

document.addEventListener('click', function(e){
  try{ setTimeout(function(){ try{ if(typeof findModalsIn === 'function') findModalsIn(document); }catch(e){} }, 120); }catch(e){}
});


